import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Radio,
  Input,
  Checkbox,
  Form,
  Button,
  InputNumber,
  message,
} from "antd";
// import { getStyleProperties } from "../../../utils/CustomFunc";
// import axios from "../../utils/BasicAuthAPI";
import "./assessment.css";
import queryString from "query-string";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import liracrypt from "../Liracrypt/liracrypt";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import SessionError from "../ApiErrorComp/SessionError";

const Assessment = (props) => {
  let history = useHistory();
  let location = useLocation();
  const params = queryString.parse(location.search);
  const [examDetail, setExamDetail] = useState(null);
  const [loginError, setLoginError] = useState(false);
  const [defaultValue, setDefaultValue] = useState(null);
  const { TextArea } = Input;

  props.setPageHeader("Assessment");
  const [form1] = Form.useForm();

  const SelectAll = (examDetails, actualV) => {
    examDetails.Questions.map((question, ind) => {
      if (question.ansTyp === "Radio") {
        form1.setFieldsValue({ [question._id]: actualV });
      }
    });
  };

  // useEffect(() => {

  //     // const params = queryString.parse(location.search);
  //     
  //     if (params.Dt && params.LID && params.Sh) {
  //         // fectchManpowerDeployment(params);
  //     }
  // }, [location.search]);

  const submitAnswer = (ans) => {
    
    liracrypt
      .post("/skillassessment", ans)
      .then(({ data }) => {
        message.success("Saved successfully!!");
        // history.push(
        //   "manpower?" +
        //     stringify({ dt: params.dt, lid: params.lid, sh: params.sh })
        // );
      })
      .catch(function (error) {
        // message.error('ERROR: Unable to save!', 4);
        console.log("Error****:");
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  const onFinish = (values) => {
    const keys = Object.keys(values);
    let ans = [];
    let postData = { ...examDetail };

    examDetail.questions.forEach((question) => {
      let quest = { ...question };
      if (values.hasOwnProperty(question._id)) {
        quest["ansGiven"] = values[question._id];
      }
      ans.push(quest);
    });
    delete postData["questions"];
    delete postData["Questions"];
    postData["answers"] = ans;
    submitAnswer(postData);
    // if (props.submitHandler) {
    //     props.submitHandler(answers);
    // }
  };

  const getOptions = (obj) => {
    switch (obj.ansTyp) {
      case "Single":
        return (
          <>
            <SessionError visible={loginError} />
            <Form.Item
              name={obj._id}
              rules={[
                {
                  required: obj.option.length > 0 ? true : false,
                  message: "Please select a option",
                },
              ]}
            >
              <Radio.Group>
                {obj.option.map((opt, i) => (
                  <Radio key={"radio" + i} value={opt.value}>
                    {opt.value}
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
          </>
        );

      case "Multi":
        return (
          <>
            <SessionError visible={loginError} />
            <Form.Item
              name={obj._id}
              rules={[
                {
                  required: obj.option.length > 0 ? true : false,
                  message: "Please select a option",
                },
              ]}
            >
              <Checkbox.Group>
                {obj.option.map((opt, i) => (
                  <Checkbox key={"check" + i} value={opt.value}>
                    {opt.value}
                  </Checkbox>
                ))}
              </Checkbox.Group>
            </Form.Item>
          </>
        );

      case "NumInt":
        return (
          <>
            <SessionError visible={loginError} />
            <Form.Item
              name={obj._id}
              rules={[
                {
                  required: obj.option.length > 0 ? true : false,
                  message: "Please enter a number",
                },
              ]}
            >
              <InputNumber />
            </Form.Item>
          </>
        );
      case "NumDec":
        return (
          <>
            <SessionError visible={loginError} />
            <Form.Item
              name={obj._id}
              rules={[
                {
                  required: obj.option.length > 0 ? true : false,
                  message: "Please enter a number",
                },
              ]}
            >
              <InputNumber step={0.1} />
            </Form.Item>
          </>
        );
      case "Text":
        return (
          <>
            <SessionError visible={loginError} />
            <Form.Item
              name={obj._id}
              rules={[
                {
                  required: obj.option.length > 0 ? true : false,
                  message: "Please Enter your answer",
                },
              ]}
            >
              <Input style={{ minWidth: "700px" }} />
            </Form.Item>
          </>
        );
      default:
        return (
          <Form.Item
            name={obj._id}
            rules={[
              {
                required: obj.option.length > 0 ? true : false,
                message: "Please select a option",
              },
            ]}
          >
            <Radio.Group defaultValue={defaultValue}>
              {obj.option.map((opt, i) => (
                <Radio key={"radio" + i} value={opt.key}>
                  {opt.value}
                </Radio>
              ))}
            </Radio.Group>
          </Form.Item>
        );
    }
  };
  useEffect(() => {
    const paramsData = { ...params };
    
    if (examDetail === null && params.dt && params.lid && params.sh) {
      liracrypt
        .get("/skillassessment", { ...paramsData })
        .then(({ data }) => {
          
          let newExamDetai = { ...data.data };
          const newData = data.data.questions.map((qes) => {
            let options = [];
            if (qes["A"]) {
              options.push({ key: "A", value: qes["A"] });
            }
            if (qes["B"]) {
              options.push({ key: "B", value: qes["B"] });
            }
            if (qes["C"]) {
              options.push({ key: "C", value: qes["C"] });
            }
            if (qes["D"]) {
              options.push({ key: "D", value: qes["D"] });
            }
            return {
              _id: qes["_id"],
              lang: qes["lang"],
              type: qes["typ"],
              qst: qes["qst"],
              ansTyp: qes["ansTyp"],
              option: options,
            };
          });
          newExamDetai["Questions"] = newData;
          setExamDetail(newExamDetai);
        })
        .catch(function (error) {
          // message.error('ERROR: Unable to save!', 4);
          console.log("Error****:");
          if (error.response !== undefined) {
            if (error.response.status !== 401) {
              // ApiErrorComp(error.response.status);
            } else {
              setLoginError(true);
            }
          }
        });
    }
  });

  const QusAns = (props) => {
    return (
      <>
        {props.examDetail.Questions.map((question, ind) => (
          <Col key={"qus" + ind} span={24} style={{ padding: "10px 10px" }}>
            <p className="question">
              <span>Q {(ind + 1 < 10 ? "0" : "") + (ind + 1)}:</span>{" "}
              {question.qst}
            </p>

            {getOptions(question)}
          </Col>
        ))}
      </>
    );
  };

  return (
    <React.Fragment>
      <Row className="assessment">
        {examDetail ? (
          <Col span={24} style={{ padding: "10px 10px" }}>
            <Row
              justify="space-between"
              style={{
                marginBottom: "20px",
                borderBottom: "1px solid #313452",
              }}
            >
              <Col span={10}>
                <p style={{ textAlign: "left", fontSize: "22px" }}>
                  Associate Name :{" "}
                  <span style={{ fontSize: "23px", fontWeight: "bold" }}>
                    {examDetail.eame}
                  </span>
                </p>
              </Col>
              <Col span={6}>
                <p style={{ textAlign: "center", fontSize: "22px" }}>
                  Skill Category :{" "}
                  <span style={{ fontSize: "23px", fontWeight: "bold" }}>
                    {examDetail["cat"]}
                  </span>
                </p>
              </Col>
              <Col span={8}>
                <p style={{ textAlign: "right", fontSize: "22px" }}>
                  Skill Level :{" "}
                  <span style={{ fontSize: "23px", fontWeight: "bold" }}>
                    {examDetail["lvl"]}
                  </span>
                </p>
              </Col>
            </Row>
          </Col>
        ) : null}
        <Form
          name="basic"
          form={form1}
          initialValues={{ remember: true }}
          onFinish={onFinish}
        >
          {examDetail &&
          examDetail.Questions &&
          Array.isArray(examDetail.Questions) &&
          examDetail.Questions.length > 0 ? (
            <React.Fragment>
              <QusAns examDetail={examDetail} />

              <Row justify="center" style={{ marginTop: "30px" }} gutter={24}>
                <Radio.Group>
                  <Radio
                    value={"YES"}
                    onClick={() => {
                      setDefaultValue("A");
                      SelectAll(examDetail, "A");
                    }}
                  >
                    Yes to All
                  </Radio>
                  <Radio
                    value={"NO"}
                    onClick={() => {
                      //
                      setDefaultValue("B");
                      SelectAll(examDetail, "B");
                    }}
                  >
                    No to All
                  </Radio>
                </Radio.Group>
              </Row>

              <Row justify="center" gutter={24}>
                <Form.Item className="formBtnGroup" label=" " colon={false}>
                  <Button
                    style={{ fontWeight: 600 }}
                    type="primary"
                    htmlType="submit"
                    id="submitBtn"
                    className="login-form-button gx-mt-1 bigBtn"
                  >
                    {"Submit"}
                  </Button>
                </Form.Item>
              </Row>
            </React.Fragment>
          ) : (
            <Col span={24} style={{ padding: "10px 10px" }}>
              <p style={{ textAlign: "center" }}>No Questions Available</p>
            </Col>
          )}
        </Form>
      </Row>
    </React.Fragment>
  );
};
export default Assessment;
